import { put, call, fork, select, takeEvery, all } from 'redux-saga/effects';
import { reset as resetForm } from 'redux-form';

import * as campaignsModule from '../modules/campaigns.module';
import * as Api from '../../core/api';

export function* fetchCampaigns({ payload: { page, itemsPerPage } }) {
  const sort = yield select((state) => state.campaigns.sort);
  const filter = yield select((state) => state.campaigns.filter);
  const { response, error } =
    yield call(Api.campaigns.fetchCampaigns, { page, itemsPerPage, sort, filter });

  if (response) {
    yield put(campaignsModule.fetchCampaignsSuccess({ campaigns: response, filter }));
  } else {
    yield put(campaignsModule.fetchCampaignsFail(error));
  }
}
export function* watchFetchCampaigns() {
  yield takeEvery(campaignsModule.fetchCampaigns.getType(), fetchCampaigns);
}

export function* fetchCampaignDetails({ payload: { campaignId } }) {
  const { response, error } = yield call(Api.campaigns.fetchCampaignDetails, campaignId);

  if (response) {
    yield put(campaignsModule.fetchCampaignDetailsSuccess(response));
  } else {
    yield put(campaignsModule.fetchCampaignDetailsFail(error));
  }
}
export function* watchFetchCampaignDetails() {
  yield takeEvery(campaignsModule.fetchCampaignDetails.getType(), fetchCampaignDetails);
}

export function* fetchCampaignsNames() {
  const { response, error } = yield call(Api.campaigns.fetchCampaignsNames);

  if (response) {
    yield put(campaignsModule.fetchCampaignsNamesSuccess(response));
  } else {
    yield put(campaignsModule.fetchCampaignsNamesFail(error));
  }
}
export function* watchFetchCampaignsNames() {
  yield takeEvery(campaignsModule.fetchCampaignsNames.getType(), fetchCampaignsNames);
}

export function* fetchCampaignsIds() {
  const { response, error } = yield call(Api.campaigns.fetchCampaignsIds);

  if (response) {
    yield put(campaignsModule.fetchCampaignsIdsSuccess(response));
  } else {
    yield put(campaignsModule.fetchCampaignsIdsFail(error));
  }
}
export function* watchFetchCampaignsIds() {
  yield takeEvery(campaignsModule.fetchCampaignsIds.getType(), fetchCampaignsIds);
}

export function* fetchCampaignsCountries() {
  const { response, error } = yield call(Api.campaigns.fetchCampaignsCountries);

  if (response) {
    yield put(campaignsModule.fetchCampaignsCountriesSuccess(response));
  } else {
    yield put(campaignsModule.fetchCampaignsCountriesFail(error));
  }
}
function* watchFetchCampaignsCountries() {
  yield takeEvery(campaignsModule.fetchCampaignsCountries.getType(), fetchCampaignsCountries);
}

export function* updateCampaign({ payload: { campaignId, revShare, capping } }) {
  const { response, error } = yield call(Api.campaigns.updateCampaign, { campaignId, revShare, capping });

  if (response) {
    yield put(campaignsModule.updateCampaignSuccess({ campaignId, revShare, capping }));
    yield put(campaignsModule.closeEditCampaign());
    yield put(resetForm('editCampaign'));
  } else {
    yield put(campaignsModule.updateCampaignFail(error));
  }
}
export function* watchUpdateCampaign() {
  yield takeEvery(campaignsModule.updateCampaign.getType(), updateCampaign);
}

export function* fetchCampaignsByCountry() {
  const { response, error } =
    yield call(Api.campaigns.fetchCampaignsByCountry);

  if (response) {
    yield put(campaignsModule.fetchCampaignsByCountrySuccess({ campaigns: response }));
  } else {
    yield put(campaignsModule.fetchCampaignsByCountryFail(error));
  }
}
export function* watchFetchCampaignsByCountry() {
  yield takeEvery(campaignsModule.fetchCampaignsByCountry.getType(), fetchCampaignsByCountry);
}

export function* fetchCampaignsByCategory() {
  const { response, error } =
    yield call(Api.campaigns.fetchCampaignsByCategory);

  if (response) {
    yield put(campaignsModule.fetchCampaignsByCategorySuccess({ campaigns: response }));
  } else {
    yield put(campaignsModule.fetchCampaignsByCategoryFail(error));
  }
}
export function* watchFetchCampaignsByCategory() {
  yield takeEvery(campaignsModule.fetchCampaignsByCategory.getType(), fetchCampaignsByCategory);
}

export default function* watchCampaigns() {
  return yield all([
    fork(watchFetchCampaigns),
    fork(watchFetchCampaignDetails),
    fork(watchFetchCampaignsNames),
    fork(watchFetchCampaignsCountries),
    fork(watchUpdateCampaign),
    fork(watchFetchCampaignsIds),
    fork(watchFetchCampaignsByCountry),
    fork(watchFetchCampaignsByCategory),
  ]);
}




/** WEBPACK FOOTER **
 ** ./js/redux/saga/campaigns.saga.js
 **/